import React, { useEffect, useState } from "react";
import useFetch from "hooks/useFetch";
import { Modal, Button, Form, Table } from "react-bootstrap";
import Loading from "components/Loading";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
export default function FiltersIndex() {
  const { t } = useTranslation();
  const [filters, setFilters] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newFilterName, setNewFilterName] = useState("");
  const [creating, setCreating] = useState(false);
  const { get, post, destroy, isLoading } = useFetch();
  const history = useHistory();

  useEffect(() => {
    fetchFilters();
  }, []);

  const fetchFilters = async () => {
    const data = await get("/admin/profile_filters");
    setFilters(data);
  };

  const handleCreateFilter = async () => {
    if (!newFilterName.trim()) return;
    setCreating(true);
    const data= await post("/admin/profile_filters", {
      name: newFilterName,
    });
    setFilters([...filters, data]);
    setNewFilterName("");
    setShowModal(false);
    setCreating(false);
    history.push(`/admin/profilefilters/${data.id}`);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Confirmer la suppression ?")) return;
    await destroy(`/admin/profile_filters/${id}`);
    setFilters(filters.filter((f) => f.id !== id));
  };

  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="mb-0">Filtres disponibles</h3>
        <button className="btn btn-outline-dark" onClick={() => setShowModal(true)}>
          + {t("admin:new_filter")}
        </button>
      </div>

      {isLoading ? (
        <div className="text-center mt-5">
          <Loading />
        </div>
      ) : filters.length === 0 ? (
        <div className="text-center py-5">
          <h5 className="text-muted">Aucun filtre disponible pour le moment.</h5>
        </div>
      ) : (
        <div className="table-responsive p-0 mb-0">
          <Table striped bordered hover className="table mb-0">
            <thead className="thead-light">
              <tr>
                <th>{t("admin:filter_name")}</th>
                <th className="text-nowrap">{t("admin:actions")}</th>
              </tr>
            </thead>
            <tbody>
              {filters.map((filter) => (
                <tr key={filter.id}>
                  <td>{filter.name}</td>
                  <td>
                    <button className="btn btn-sm btn-outline-secondary mr-2" onClick={() => history.push(`/admin/profilesfilter/${filter.id}/edit`)}>
                      {t("admin:edit")}
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleDelete(filter.id)}
                    >
                      {t("admin:delete")}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}


      {showModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content rounded-lg">
              <div className="modal-header">
                <h5 className="modal-title">Créer un nouveau filtre</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setShowModal(false)}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nom du filtre"
                  value={newFilterName}
                  onChange={(e) => setNewFilterName(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  {t("admin:cancel")}
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleCreateFilter}
                >
                  {t("admin:validate")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
